import { LOCALES, useI18n } from '@/lib/i18n';

export function LanguageSwitcher({ className = '' }: { className?: string }) {
  const { locale, setLocale } = useI18n();

  return (
    <div
      role="group"
      aria-label="Language"
      className={`inline-flex shrink-0 items-center gap-0.5 rounded-xl border border-heritage-200 bg-surface p-0.5 ${className}`}
    >
      {LOCALES.map((item) => (
        <button
          key={item.code}
          type="button"
          onClick={() => setLocale(item.code)}
          aria-pressed={locale === item.code}
          title={item.label}
          className={`rounded-lg px-2 py-1.5 text-xs font-semibold uppercase transition ${
            locale === item.code
              ? 'bg-heritage-600 text-white'
              : 'text-heritage-500 hover:bg-heritage-100 hover:text-heritage-800'
          }`}
        >
          {item.code}
        </button>
      ))}
    </div>
  );
}
